
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { CSNMemberResponse } from '../../../../../shared/models/member-response.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-membership-overview',
  imports: [TranslateModule, CommonModule],
  // templateUrl: './membership-overview.component.html',
  template: `
    <h2 class="text-lg font-semibold mb-4 text-dc-black">
      {{ 'ACCOUNT.MEMBERSHIP.TITLE' | translate }}
    </h2>
    @if (rows && rows.length > 0) {
    <table class="dc-table">
      <tbody>
        @for (row of rows; track $index) {
          <tr>
            <td class="w-70">{{ row.label | translate }}</td>
            <td class="py-4! text-dc-navy font-semibold">
              @if (row.label == 'ACCOUNT.MEMBERSHIP.RENEW' || row.label == 'ACCOUNT.MEMBERSHIP.ISSUE_DATE') {
              {{ row.value | date : "dd MMMM yyyy" }}
              } @else {
                {{ row.value }}
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
    
    
      }
    `,
  styleUrl: './membership-overview.component.scss'
})
export class MembershipOverviewComponent {
  @Input() details: any;

  // This method is used to initialize the class instance
  constructor() {
    this.details = {} as CSNMemberResponse;
  }

  // This method is used to rows
  get rows() {
    return [
      { label: 'ACCOUNT.MEMBERSHIP.NUMBER', value: this.details ? this.details.CSN : "" },
      { label: 'ACCOUNT.MEMBERSHIP.RENEW', value: this.details ? this.details['DC Expiry Date'] : "" },
      { label: 'ACCOUNT.MEMBERSHIP.TRADE_LICENSE', value: this.details ? this.details['DC License Registration Number'] : "" },
      // { label: 'ACCOUNT.MEMBERSHIP.REGISTRATION', value: '-' },
      { label: 'ACCOUNT.MEMBERSHIP.TRADE_NAME', value: this.details ? this.details['DC Name English'] : "" },
      { label: 'ACCOUNT.MEMBERSHIP.LEGAL', value: this.details ? this.details['DC Legal Status'] : "" },
      { label: 'ACCOUNT.MEMBERSHIP.LICENSE_ISSUING_AUTHORITY', value: this.details ? this.details['DC License Issue Authority'] : "" },
      { label: 'ACCOUNT.MEMBERSHIP.TRADE_LICENSE_TYPE', value: this.details ? this.details['DC License Type'] : "" },
      { label: 'ACCOUNT.MEMBERSHIP.ISSUE_DATE', value: this.details ? this.details['Customer Since'] : "" },
    ];
  }
}
